import { render, staticRenderFns } from "./ContactDM2Modal.vue?vue&type=template&id=ff7c39c0&scoped=true&"
import script from "./ContactDM2Modal.vue?vue&type=script&lang=js&"
export * from "./ContactDM2Modal.vue?vue&type=script&lang=js&"
import style0 from "./ContactDM2Modal.vue?vue&type=style&index=0&id=ff7c39c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7c39c0",
  null
  
)

export default component.exports